module.exports = __webpack_public_path__ + "static/img/mac1.682e024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hiw/mac1.png
// module id = 216
// module chunks = 1